module.exports = __webpack_public_path__ + "static/media/poster_Godfrey.eafc9b53.png";